/** Adaptive learning routes — Study hub rail, mobile drawer, etc. */
export const LEARNING_NAV = {
  today: { path: '/hub/today', label: "Today's plan", shortLabel: 'Today' },
  mastery: { path: '/mastery', label: 'Knowledge map', shortLabel: 'Mastery' },
  tutor: { path: '/tutor', label: 'AI Tutor', shortLabel: 'Tutor' },
  interview: { path: '/interview', label: 'Mock interview', shortLabel: 'Interview' },
  skillGap: { path: '/skill-gap', label: 'Skill gap', shortLabel: 'Skill gap' },
  weekly: { path: '/weekly-summary', label: 'Weekly summary', shortLabel: 'Weekly' },
};

export const LEARNING_MENU = [
  LEARNING_NAV.today,
  LEARNING_NAV.mastery,
  LEARNING_NAV.tutor,
  LEARNING_NAV.interview,
  LEARNING_NAV.skillGap,
  LEARNING_NAV.weekly,
];
